// extracted by css-extract-rspack-plugin
export default {"clicked":"ClickableDiv-module__clicked--WYD4k"};